export class User {
  login_id: string;
  name: string;
  role: string;
  curriculum_id: string;
  school_id: string;
  password: string;
  touan_upload_auth: boolean = false;
  scoring_auth: boolean = false;
  pending_scoring_auth: boolean = false;
  aggregate_auth: boolean = false;
  broese_auth: boolean = false;
  curriculums: Curriculum[] = new Array<Curriculum>();

  constructor(curriculums: any[]){
    curriculums.forEach((x: any) => {
      this.curriculums.push(new Curriculum(x, false));
    });
  }
}

export class Curriculum {
  id: number
  name: string
  is_selected: boolean

  constructor(curriculum: any, is_selected: boolean){
    this.id = curriculum.id;
    this.name = curriculum.name;
    this.is_selected = is_selected;
  }
}

export class Room {
  id: number
  room_code: number
  name: string

  constructor(room: any){
    this.id = room.id;
    this.room_code = room.room_code;
    this.name = room.name;
  }
}